import { Component, DoCheck, OnInit } from '@angular/core';
import { UserBasicInfo } from '../../modules/buildings-shared/model/user-basic-info';
import { ActivatedRoute, Params, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';
import { AccountInfo } from '../../modules/buildings-shared/model/account-info';
import { EncodeErrorInfo } from '../../modules/buildings-shared/model/encode-error-info';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormControlValidators } from '../../modules/buildings-shared/utilities/form-control-validators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-password-forgot-retrieve',
  imports: [RouterLink, RouterLinkActive, ReactiveFormsModule, CommonModule],
  templateUrl: './password-forgot-retrieve.component.html',
  styleUrl: './password-forgot-retrieve.component.scss'
})
export class PasswordForgotRetrieveComponent implements OnInit {

    private token: string | undefined;
    private accountInfo: AccountInfo | undefined;

    changePasswordForm: FormGroup;

    passwordHidden: boolean = true;
    passwordConfirmHidden: boolean = true;

    constructor(private formBuilder: FormBuilder, private readonly router: Router, private readonly permissionService: PermissionService,
                private readonly activatedRoute: ActivatedRoute
    ) {
            this.changePasswordForm = this.generateForm();
        }
    
    ngOnInit(): void {
       this.permissionService.setWaitingSpinner(true);
        this.activatedRoute.queryParams.subscribe ( (params: Params) => {
            if (params && params["token"] && params["token"].length > 0) {
                this.token = decodeURIComponent(params["token"]);
                this.permissionService.forgotPasswordAccount(this.token ?? "").then( (accountInfo: AccountInfo) => {
                    this.accountInfo = accountInfo;
                    if(this.accountInfo && this.accountInfo.email) {
                        this.permissionService.setWaitingSpinner(false);
                        this.permissionService.alert("Ciao " + this.accountInfo.nickname + "! Imposta una nuova password per il tuo account").then( (data: boolean) => {
                            console.log("MODAL CLOSED ... RESULT: " + data);
                        });
                    }
                }).catch( async (error: any) => {
                    const returnedError: EncodeErrorInfo = error.error;
                    console.error("AccountActivateComponent.ngOnInit() - an error occurred. EROR CODE: " + (returnedError.code ?? (error.code ?? error.message) ) );
                    let modalMessage: string;
                    switch(returnedError.code) {
                        case "email_token_not_found": {
                            modalMessage = "La richiesta di reset della password non è più valida. Esegui nuovamente la procedura.";
                            break;
                        }
                        case "email_token_expired": {
                            modalMessage = "La richiesta di reset della password è scaduta: esegui nuovamente la procedura.";
                            break;
                        }
                        case "user_not_found": {
                            modalMessage = "L'utente non è stato trovato: esegui nuovamente la richiesta di reset della password.";
                            break;
                        }
                        default: {
                            modalMessage = "Si è verificato un problema durante la procedura di reset della password: riprova più tardi.";
                        }
                    }
                    this.permissionService.setWaitingSpinner(false);
                    this.permissionService.alert(modalMessage).then( (data: boolean) => {
                        console.log("MODAL CLOSED ... RESULT: " + data);
                        this.router.navigateByUrl("login");
                    });
                });
            } else {
                this.permissionService.setWaitingSpinner(false);
                this.permissionService.alert("La richiesta di modifica della password non è valida. Esegui nuovamente la procedura oppure contatta l'assistenza.");
            }
        });
    }

    generateForm(): FormGroup {
        return this.formBuilder.group( {
            password: ['', [
                Validators.required,
                Validators.minLength(8),
                Validators.maxLength(50),
                FormControlValidators.patternValidator( /\d/, { hasNumber: true } ),
                FormControlValidators.patternValidator( /[A-Z]/, { hasCapitalCase: true } ),
                FormControlValidators.patternValidator( /[a-z]/, { hasSmallCase: true } ),
                FormControlValidators.patternValidator( /[!@#$%^&*()_+\-=\\\[\]{};':"|,.<>?]/, { hasSpecialCharacters: true } )
            ]],
            passwordConfirm: ['']
        }, { validators: [FormControlValidators.passwordMatchValidator] });
    }

    async onSubmit() {
        this.permissionService.setWaitingSpinner(true);
        this.accountInfo!.password = '';
        this.accountInfo!.password = await this.permissionService.encryptData(this.changePasswordForm.get("password")?.value, environment.buildingsMembershipEncryptSalt);
        
        this.permissionService.forgotPasswordChange(this.accountInfo!, this.token ?? "").then((data: boolean) => {
            this.permissionService.setWaitingSpinner(false);
            if(!!data) {
                this.permissionService.alert("La tua password è stata cambiata con successo.").then(() => {
                    this.router.navigateByUrl("login");
                });
            } else {
                this.permissionService.alert("Si è verificato un errore durante il cambio della password.").then(() => {
                    console.error("PasswordForgotRetrieveComponent.onSubmit() - Password change failed for user: " + this.accountInfo?.nickname);
                });
            }
        });


/***********************************
        this.permissionService.signup(this.accountInfo).then((data: boolean) => {
            const registrationSucceeded: boolean = data;
            if (registrationSucceeded) {
                console.info("RegisterComponent.onSubmit() - New success signup: " + this.accountInfo.nickname);
            } else {
                console.info("RegisterComponent.onSubmit() - Signup failed for user: " + this.accountInfo.nickname);
            }
            this.router.navigateByUrl("registerComplete/" + registrationSucceeded + "/" + this.accountInfo.nickname);
        }).catch((error: any) => {
            const returnedError: EncodeErrorInfo = error.error;
            console.error("RegisterComponent.onSubmit() - An error occurred: " + (returnedError.code ?? (error.code ?? error.message) ) );
            if(returnedError?.code && returnedError.code === 'nickname_busy') {
                this.nicknameBusy = returnedError;
            } else if(returnedError?.code && returnedError.code === 'email_busy') {
                this.emailBusy = returnedError;
            } else {
                this.router.navigateByUrl("registerComplete/false");
            }
            this.registerForm.controls["nickname"].updateValueAndValidity();
            this.registerForm.controls["email"].updateValueAndValidity();
        });
        *********************/
    }
}
